module.exports = __webpack_public_path__ + "static/img/华为Mate X6.de3bba43.png";